import { useCallback, useEffect, useState } from "react";

const useMediaQuery = (width: number) => {
  const [reached, setReached] = useState(false);

  const updateTarget = useCallback((e) => {
    if (e.matches) {
      setReached(true);
    } else {
      setReached(false);
    }
  }, []);

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${width}px)`);
    media.addEventListener("change", (e) => updateTarget(e));

    if (media.matches) {
      setReached(true);
    }

    return () => media.removeEventListener("change", (e) => updateTarget(e));
  }, [updateTarget, width]);

  return reached;
};

export default useMediaQuery;
